/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_TrackerInputs */

const en_mk_cmp_r_tracker = /** @type {(inputs: Mk_Cmp_R_TrackerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A firm work tracker`)
};

const id_mk_cmp_r_tracker = /** @type {(inputs: Mk_Cmp_R_TrackerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacak pekerjaan yang tegas`)
};

/**
* | output |
* | --- |
* | "A firm work tracker" |
*
* @param {Mk_Cmp_R_TrackerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_tracker = /** @type {((inputs?: Mk_Cmp_R_TrackerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_TrackerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_tracker(inputs)
	return en_mk_cmp_r_tracker(inputs)
});